import React, { useEffect } from 'react';
import { useStore, useActions } from '@app/store/models';
import { DataGrid } from '@digital/ui';


export default () => {
 

  useEffect(() => {
 
  }, []);

};
